import { configureStore } from '@reduxjs/toolkit';

import dataReducer from './dataSlice';
import categoryReducer from './categorySlice';

import {
  setErrorAction,
  setDataAction,
  setLoadingAction,
  fetchPages,
} from './dataSlice';
import {
  setCategoryDataAction,
  setCategoryErrorAction,
  setCategoryLoadingAction,
  fetchCategories,
} from './categorySlice';

const store = configureStore({
  reducer: {
    data: dataReducer,
    category: categoryReducer,
  },
});

export default store;
export {
  setDataAction,
  setErrorAction,
  setLoadingAction,
  fetchPages,
  setCategoryDataAction,
  setCategoryErrorAction,
  setCategoryLoadingAction,
  fetchCategories,
};
